// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2ljZt","title":"AfterBackImages_title__1bEuy","images":"AfterBackImages_images__2wZxH"};